module.exports = __webpack_public_path__ + "static/media/image-card-8.2074d151.png";